import {defaultSelectedHallazgo} from './state';
import {defaultItem} from './state';

const moment = require('moment');

/**
 *
 * @param {*} state
 * @param {*} hallazgos
 */
export function setListarHallazgos(state, hallazgos) {
    hallazgos.data.forEach(element => {
        element.seguimientos.forEach(i => {
            i.fecha_seguimiento = moment().format('YYYY-MM-DD ');
            i.fecha_cierre = moment().format('YYYY-MM-DD ');
        });
    });
    state.hallazgos = hallazgos;
}

/**
 *
 * @param {*} state
 * @param {*} hallazgos
 */
export function setVerHallazgo(state, hallazgos) {
    state.selectedHallazgo = hallazgos;
}

/**
 *
 * @param {*} state
 * @param {*} graficas
 */
export function setGraficas(state, graficas) {
    state.graficaGeneral = Object.assign({}, graficas.data[0], graficas.data[1]);
    state.datoGrafica1 = graficas.data[0];

    state.graficaTipoSeg = graficas.data2;
    graficas.data2.forEach(el => {
        state.datoGrafica2.push([
            el.key,
            el.value
        ]);
    });
}

/**
 * Metodo para bloquear dinámicamente el formulario por secciones al guardar
 *
 * @param {*} state
 * @param {*} itemGuardado
 */
export function itemGuardado(state, itemGuardado) {
    state.listaTipoSeguimientos.forEach(i => {
        let items = i.items_lista_chequeos.length > 0 ? i.items_lista_chequeos : i.items;
        items.forEach(e => {
            if (itemGuardado === e.id_tipo_seguimiento) {
                e.guardado = 1;
            }
        });
    });
}

/**
 *
 * @param {*} state
 * @param {*} listaChequeo
 */
export function cargaHallazgos(state, hallazgo) {
    state.hallazgoArr = [];
    let items = hallazgo.items_lista_chequeos.length > 0 ? hallazgo.items_lista_chequeos : hallazgo.items;
    items.forEach(e => {
        let hall = state.hallazgoArr.find(h => h.id_item === e.id && h.id_tipo_seguimiento === e.id_tipo_seguimiento);

        if (!hall) {
            state.hallazgoArr.push({
                id_empresa: state.id_empresa,
                id_lista_chequeo: state.id_lista_chequeo,
                id_tipo_seguimiento: e.id_tipo_seguimiento,
                id_item: e.id,
                ubicacion: e.ubicacion || '',
                cumple: e.cumple || '',
                observaciones: e.observaciones || '',
                opciones_mejora: e.opciones_mejora || '',
                legislacion: e.legislacion || '',
            });
        }
    });
}

export function setPermisosAdmin(state, permiso) {
    state.esAdmin = permiso;
}

export function setPermisosEmpresa(state, permiso) {
    if (!state.esAdmin) {
        state.esEmpresa = permiso;
    }
}

export function setListaImagenes(state, imagenes) {
    if (imagenes[0]) {
        const verificarPlaneacion = Object.keys(imagenes[0]);
        if (verificarPlaneacion.indexOf('registro') != -1) {
            for (var i = 0; i < imagenes.length; i++) {
                imagenes[i].imagen = imagenes[i].registro;
                imagenes[i].mostrar_imagen = i < 2 ? 1 : 0;
            }
        }
    }

    state.arrImage = imagenes;
}

export function setfiltroRegistro(state, buscar) {
    state.filtroImagen.id_empresa = state.id_empresa;
    state.filtroImagen.id_lista_chequeo = state.id_lista_chequeo;
    state.filtroImagen.id_item = buscar.id;
}

export function imagenUpdate(state, registro) {
    state.imagenSelecc = registro;
}

export function imagenCambiar(state, image) {
    state.imagenChange = image;
}

/**
 *
 * @param {*} state
 * @param {*} listaChequeo
 */
export function asignarEmpresa(state, listaChequeo) {
    state.id_empresa = listaChequeo.id_empresa;
    state.id_lista_chequeo = listaChequeo.id;
}

/**
 *
 * @param {*} state
 * @param {*} hallazgos
 */
export function hacerObjeto(state, hallazgos) {
    state.hallazgoObjetos = Object.assign({}, hallazgos);
}

/**
 *
 * @param {*} state
 * @param {*} listaChequeo
 */
export function setHallazgoEmpresa(state, listaChequeo) {
    state.id_empresa = listaChequeo.id_empresa;
}

/**
 *
 * @param {*} state
 * @param {*} buscar
 */
export function setFiltroGraficas(state, listaChequeo) {
    state.filtro_graficas.id_empresa = listaChequeo.id_empresa;
    state.filtro_graficas.id_lista_chequeo = listaChequeo.id; //TODO poner el id de la lista de chequeo
}

/**
 *
 * @param {*} state
 * @param {*} accion
 */
export function setAccion(state, accion) {
    state.accion = accion;
}

/**
 *
 * @param {*} state
 */
export function accionError(state) {
    state.error = true;
}


export function setFiltroEmpresaHallazgo(state, buscar) {
    state.filtro.id_empresa = buscar;
}

/**
 *
 * @param {*} state
 * @param {*} tipoSeguimientos
 */
export function setEditarTipoSeguimiento(state, tipoSeguimientos) {
    state.listaTipoSeguimientos = tipoSeguimientos;
}

export function setParametroSeguimiento(state, id) {
    state.lista.id_tipo_lista_chequeo = id;
}


export function setPage(state, page) {
    state.filtro.page = page;
}

/**
 *
 * @param {*} state
 */
export function resetSelectedHallazgo(state) {
    Object.assign(state.selectedHallazgo, defaultSelectedHallazgo());
}

/**
 * Mutacion para cargar la informacion de plan de acción.
 *
 * @param {*} state
 * @param {*} plan_accion
 */
export function setPlanAccion(state, plan_accion) {

    state.datos_accion = {
        responsable: '',
        fecha_inicio_visita: '',
        fecha_cierre_visita: ''
    };

    state.plan_accion = plan_accion;

    state.datos_accion.id = plan_accion.data.id;
    state.datos_accion.responsable = plan_accion.data.responsable;
    state.datos_accion.fecha_inicio_visita = plan_accion.data.fecha_inicio_visita;
    state.datos_accion.fecha_cierre_visita = plan_accion.data.fecha_cierre_visita;
}

/**
 * Mutacion para resetear valores del cumple al agregar nuevos hallazgos
 *
 * @param {*} state
 */
export function resetListaTipoSeguimientos(state) {
    state.listaTipoSeguimientos.forEach(i => {
        i.items.forEach(e => {
            e.cumple = null;
        });
    });
}

/**
 * Actualiza la visualizacion del modal para modificar las columnas de hallazgos
 * @param {*} state
 * @param {*} show
 */
export function setFindingModal(state, show) {
    state.findingModal.show = show;
}

/**
 * Selecciona el item de los hallazgos a editar
 *
 * @param {*} state
 * @param {*} item
 */
export function setItemFinding(state, item) {
    state.item = item;
}

/**
 * Selecciona el item de los hallazgos a editar
 *
 * @param {*} state
 */
export function resetItemFinding(state) {
    state.item = defaultItem();
}


